import script from "./ColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorPicker.vue?vue&type=script&setup=true&lang=js"

import "./ColorPicker.vue?vue&type=style&index=0&id=ca25469e&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca25469e"]])

export default __exports__